

















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import TextField from '@/reusable/Form/TextField.vue';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Snotify } from '@/snotify/Snotify';
import { LoadingService } from '@/services/loadingService';
import { Funcionalidades } from '@/config/funcionalidades';
import { fetchReportesSerie } from '../fetchReporteSerie';
import moment from 'moment';
import { Validator } from 'vee-validate';

import config from '@/config/index';
@Component({
  components: {
    TextField,
    FormFieldsContainer,
  },
})
export default class TelcoFormGeneral extends Vue {
  @Prop({ default: false }) modoVer: boolean;
  @Prop({ default: false }) nuncaEdit: boolean;
  @Prop({ default: false }) modoEditar: boolean;

  @Prop({ default: null }) telcoid: any;
  @Prop({ default: null }) telconame: any;
  @Prop({ default: null }) telcoprefix: any;
  @Prop({ default: null }) usuarioID: any;
  @Prop({ default: null }) estadoSelected: any;
  dictionaryFormErrors: any = {};
  readonly $snotify: Snotify;

  readonly loadingService = new LoadingService();
  axios: AxiosVue = new AxiosVue(ServicioProxy.Integracion);
  readonly funcionalidad: Funcionalidades = Funcionalidades.MantenedorTelco;
  initialize() {
    this.dictionaryFormErrors = {
      custom: {
        prefix: {
          required: () => config.errorMensajes.textoRequerido,
          numeric: config.errorMensajes.soloNumeros,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }

  private registrarValidadores() {
    const self = this;
    Validator.extend('validateNumberAndSemicolon', {
      getMessage(field: any, params: any, data: any) {
        return (
          (data && data.message) ||
          '* El campo solo puede incluir numeros separados por punto y coma'
        );
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: /^[0-9;]*$/.test(value),
            data:
              value == true
                ? undefined
                : {
                    message:
                      '* El campo solo puede incluir numeros separados por punto y coma',
                  },
          });
        });
      },
    });
  }

  estados: Array<String> = ['ACTIVO', 'INACTIVO'];
  formFields: FormFieldDefMap = {
    id: {
      label: 'Telco Id',
      id: this.telcoid,
      value: this.telcoid,
    },
    telconame: {
      label: 'Nombre',
      id: this.telconame,
      value: this.telconame,
    },
    telcoprefix: {
      label: 'Prefijo',
      id: this.telcoprefix,
      value: this.telcoprefix,
    },
    usuario: {
      label: 'Usuario Modificador',
      id: JSON.parse(localStorage.getItem('user')).nombre,
      value: JSON.parse(localStorage.getItem('user')).nombre,
    },
    fecha: {
      label: 'Fecha de Modificación',
      id: moment().format('YYYY-MM-DD h:mm:ss'),
      value: moment().format('YYYY-MM-DD h:mm:ss'),
    },
    estado: {
      label: 'Estado',
      id: '',
      value: this.estadoSelected,
    },
  };
  async editar() {
    let self = this;
    this.loadingService.showLoading();
    if (this.formFields.telconame.value == '') {
      self.$snotify.error('Debe incluir un Nombre para editar el Telco', {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
      return;
    }
    if (this.formFields.telcoprefix.value == '') {
      self.$snotify.error('Debe incluir minimo un prefijo Telco', {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
      return;
    }
    return fetchReportesSerie(
      {
        usuarioid: JSON.parse(localStorage.getItem('user')).id,
        usuariorut: JSON.parse(localStorage.getItem('user')).rutClienteDefecto,
        clienteid: JSON.parse(localStorage.getItem('clienteDefecto')),
        bmoduloid: this.funcionalidad,
        telconame: this.formFields.telconame.value.toString().toUpperCase(),
        telcoprefix: this.formFields.telcoprefix.value,
        telcoid: this.telcoid,
        estado: this.formFields.estado.value,
      },
      'mantenedor_telco/editar_telco'
    )
      .then(async (data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  inactivo: boolean = false;
  mounted() {
    if (this.estadoSelected == 'INACTIVO') this.inactivo = true;
    this.initialize();
    this.registrarValidadores();
  }
}
